import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/cart';
import toast from 'react-hot-toast';
import '../styles/QuickView.css';

const QuickView = ({ product, onClose }) => {
  const navigate = useNavigate();
  const [cart, setCart] = useCart();

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    const handleEsc = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handleEsc);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleEsc);
    };
  }, [onClose]);

  if (!product) return null;

  return (
    <div className="qv-overlay" onClick={onClose}>
      <div className="qv-modal" onClick={(e) => e.stopPropagation()}>
        <button className="qv-close" onClick={onClose}>&times;</button>

        <div className="qv-content">
          {/* Image */}
          <div className="qv-image-section">
            <div className="qv-image-wrapper">
              <img
                src={`/api/v1/products/product-photo/${product._id}`}
                alt={product.name}
              />
            </div>
          </div>

          {/* Details */}
          <div className="qv-details-section">
            <div className="qv-brand-tag">{product?.category?.name || ''}</div>
            <h2 className="qv-name">{product.name}</h2>

            <div className="qv-price">
              <span className="qv-price-value">{product.price?.toLocaleString("ar-IQ")}</span>
              <span className="qv-price-currency">د.ع</span>
            </div>

            <div className="qv-divider"></div>

            <p className="qv-description">{product.description}</p>

            <div className="qv-stock">
              <span className={`qv-stock-badge ${product.quantity > 0 ? 'in-stock' : 'out-stock'}`}>
                {product.quantity > 0 ? `متوفر (${product.quantity})` : 'غير متوفر'}
              </span>
            </div>

            <div className="qv-actions">
              <button
                className="qv-btn qv-btn-cart"
                onClick={() => {
                  setCart([...cart, product]);
                  localStorage.setItem("cart", JSON.stringify([...cart, product]));
                  toast.success("تمت الإضافة إلى السلة");
                }}
              >
                🛒 أضف إلى السلة
              </button>
              <button
                className="qv-btn qv-btn-details"
                onClick={() => {
                  onClose();
                  navigate(`/products/${product.slug}`);
                }}
              >
                عرض التفاصيل الكاملة
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickView;
